import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

export const fetchAllBranchaesbyId = (params) => {
  return Api(endPoints.fetchAllBranchaesbyId, params, requestType.POST);
};

export const fetchBusinessDetailById = (id) => {
  return Api(
    `${endPoints.fetchBusinessDetailById}/${id}`,
    null,
    requestType.GET
  );
};

// **************** NEW FLOW WORK **************** //

export const getBranchDetails = (id) => {
  return Api(`${endPoints.getBranchDetails}/${id}`, null, requestType.GET);
};

export const fetchBranchaesbyId = (type, ids) => {
  return Api(
    `${endPoints.getBranches}?type=${type}&businessId=${ids}`,
    null,
    requestType.GET
  );
};
export const createBranch = (params) => {
  return Api(endPoints.createBranch, params, requestType.POST);
};
export const updateBranch = (id, params) => {
  return Api(`${endPoints.updateBranch}/${id}`, params, requestType.PUT);
};
